import React, {Suspense} from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Spinner from './components/common/utility/Spinner';
import ErrorBoundary from './components/common/utility/ErrorBoundary';

/**
 * Lazy Loading
 *
 * Purpose:
 * Loads the Routing component only when it is needed,
 * helping to reduce the initial bundle size and improve
 * application performance.
 */

const Routing = React.lazy(() => import('./Routing'));

/**
 * Root React Element
 *
 * Purpose:
 * Creates the root element where the React application
 * is rendered.
 */

const root = ReactDOM.createRoot(document.getElementById('root'));

/**
 * Application Entry Point
 *
 * Purpose:
 * Renders the React application inside React.StrictMode.
 *
 * Features:
 * - React.StrictMode helps identify potential issues during development.
 * - ErrorBoundary catches render errors, including a failed chunk load for
 *   the lazy Routing component, so they do not blank the page.
 * - Suspense displays the Spinner component while the Routing
 *   component is loading asynchronously.
 */

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <Suspense fallback={<Spinner />}>
        <Routing />
      </Suspense>
    </ErrorBoundary>
  </React.StrictMode>
);
